export default {"src":"/_next/static/media/easy-keyzy.4207e0d9.svg","height":131,"width":121};